import { FormattedMessage } from 'react-intl';
import SearchRoundedIcon from '@mui/icons-material/SearchRounded';
import { alpha, Box, Chip, Paper, Stack, Typography, useTheme } from '@mui/material';

const ModernDashboardEmptyState = () => {
  const theme = useTheme();

  return (
    <Paper
      role="status"
      aria-live="polite"
      elevation={0}
      sx={{
        px: 2,
        py: { xs: 5, md: 7 },
        textAlign: 'center',
        border: '1px dashed',
        borderColor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.35 : 0.25),
        borderRadius: 2.5,
        bgcolor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.055 : 0.025),
      }}>
      <Box
        aria-hidden="true"
        sx={{
          width: 58,
          height: 58,
          mx: 'auto',
          mb: 2,
          display: 'grid',
          placeItems: 'center',
          color: theme.palette.mode === 'dark' ? theme.palette.primary.light : theme.palette.primary.dark,
          borderRadius: 2,
          bgcolor: alpha(theme.palette.primary.main, theme.palette.mode === 'dark' ? 0.16 : 0.09),
          '& .MuiSvgIcon-root': { fontSize: 30 },
        }}>
        <SearchRoundedIcon />
      </Box>
      <Typography component="h2" variant="h6" sx={{ fontWeight: 700 }}>
        <FormattedMessage id="dashboard.modern.empty.title" />
      </Typography>
      <Typography color="text.secondary" sx={{ mt: 0.75, mx: 'auto', maxWidth: 560 }}>
        <FormattedMessage id="dashboard.modern.empty.description" />
      </Typography>
      <Stack direction="row" flexWrap="wrap" justifyContent="center" gap={1} sx={{ mt: 2.25 }}>
        <Chip size="small" label={<FormattedMessage id="dashboard.companies" />} />
        <Chip size="small" label={<FormattedMessage id="dashboard.products" />} />
        <Chip size="small" label={<FormattedMessage id="dashboard.modern.empty.connections" />} />
      </Stack>
    </Paper>
  );
};

export default ModernDashboardEmptyState;
